import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ReactTable from "react-table";
import moment from "moment";
import CollectionOverride from "components/CollectionOverride";


export default class LogsAcquisition extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions_Logs._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_ACQUISITIONS';

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Date Changed",
				id: "date",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "User",
				id: "user",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => (obj.user ? obj.user : 'Owner')
			},
			{
				Header: "Field",
				id: "field",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => (obj.field)
			},
			{
				Header: "Original",
				id: "value_original",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => (!obj.display_old ? (obj.value_original?obj.value_original:"Blank" ): obj.display_old)
			},
			{
				Header: "New",
				id: "value_new",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => (!obj.display_new ? (obj.value_new?obj.value_new:"Blank" ): obj.display_new)
			},
			{
				Header: "Note",
				id: "note",
				/** @param {Transactions_Logs_Object} obj */
				accessor: obj => (obj.note)
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Acquisition Logs', "")}
							{this.renderHeaderRight("Acquisition Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	};

}
